import { render, staticRenderFns } from "./ModItemHeader.vue?vue&type=template&id=67a7eec5&scoped=true&"
import script from "./ModItemHeader.vue?vue&type=script&lang=ts&"
export * from "./ModItemHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ModItemHeader.vue?vue&type=style&index=0&id=67a7eec5&scoped=true&lang=scss&"
import style1 from "./ModItemHeader.vue?vue&type=style&index=1&id=67a7eec5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a7eec5",
  null
  
)

export default component.exports